export default [
  {
    leistungstext: "Folgeschäden bei privatem Schlüsselverlust",
    infoText: "",
    leistungen: ["Nein", "Nein", "10.000 €"],
  },
  {
    leistungstext: "Bauherrenrisiko bis zur Bausummenhöhe",
    infoText: "",
    leistungen: ["100.000 €", "250.000 €", "500.000 €"],
  },
  {
    leistungstext: "Bauen in Eigenregie bis zur Bausummenhöhe",
    infoText: "",
    leistungen: ["100.000 €", "100.000 €", "200.000 €"],
  },
  {
    leistungstext: "Versicherungspflichtige motorisierte Flugmodelle (z. B. Drohnen und Quadrokopter)",
    infoText: "Die Haftpflicht für Flugmodelle ist bis 250 g oder 5 kg mitversichert.",
    leistungen: ["bis 250 g", "bis 250 g", "bis 5 kg"],
  },
  {
    leistungstext: "Übernahme der Vollkasko-SB* bei einem mit dem Kfz von privaten Dritten verschuldeten Unfall",
    infoText: "",
    leistungen: ["Nein", "Nein", "Ja"],
  },
  {
    leistungstext:
      "Übernahme von Vermögensschäden durch SFR**-Rückstufung in der Kraftfahrt-Haftpflicht- und Vollkasko-Versicherung",
    infoText: "",
    leistungen: ["Nein", "Nein", "Ja"],
  },
  {
    leistungstext: "Schäden beim Öffnen der Kfz-Tür",
    infoText: "",
    leistungen: ["Nein", "Nein", "Ja"],
  },
  {
    leistungstext: "Be- und Entladeschäden",
    infoText: "",
    leistungen: ["Nein", "Nein", "Ja"],
  },
  {
    leistungstext: "Schäden durch im europäischen Ausland gemieteten Kfz (Mallorcadeckung)",
    infoText:
      "Wir bieten ergänzenden Versicherungsschutz auch für Kfz-Haftpflichtschäden bei Mietwägen innerhalb Europas.",
    leistungen: ["Nein", "Nein", "Ja"],
  },
  {
    leistungstext: "Betankungsschäden an gemieteten Fahrzeugen",
    infoText:
      "Wir bieten ergänzenden Versicherungsschutz auch für Kfz-Haftpflichtschäden bei Mietwägen innerhalb Europas.",
    leistungen: ["Nein", "Nein", "10.000 €"],
  },
  {
    leistungstext: "Nebentätigkeit bis Jahresumsatz von",
    infoText:
      "Haftpflichtansprüche aus bestimmten selbständigen und/oder freiberuflichen Nebentätigkeiten sind im Rahmen der angegebenen Summe mit abgesichert. Dies beschränkt sich auf<ul><li>Alleinunterhalter</li><li>Annahmestellen für Sammelbesteller</li><li>Änderungsschneiderei, Stickerei</li><li>Daten- und Texterfassung</li><li>Fotografen</li><li>Frisöre</li><li>Kunsthandwerker (z. B. Töpfer)</li><li>Lehrer (nebenberuflich, z. B. Nachhilfe oder Musiklehrer)</li><li>Markt- und Meinungsforschung</li><li>Tierbetreuung</li><li>Trageberater</li><li>Übersetzer</li><li>Verkauf auf Flohmärkten und Basaren</li><li>Vertrieb von Kosmetika, Haushaltsartikeln und Schmuck</li></ul>Der Versicherer ist von der Verpflichtung zur Leistung frei, wenn der Umsatz aus dieser Tätigkeit in den letzten 12 vollen Monaten vor Schadeneintritt den angegeben Betrag übersteigt.",
    leistungen: ["Nein", "6.000 €", "25.000 €"],
  },
  {
    leistungstext: "Forderungsausfall-Deckung",
    infoText:
      "Sind Sie selbst Geschädigter und der Schadenverursacher kann den Schaden nicht begleichen, leisten wir unter bestimmten Voraussetzungen für Ihren Forderungsausfall.",
    leistungen: ["Mindestschadenhöhe 2.500 €", "Ja", "Ja"],
  },
  {
    leistungstext: "E-Ladestation/Wallbox",
    infoText: "",
    leistungen: ["Ja", "Ja", "Ja"],
  },
];
